var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"lg":"12"}},[_c('CTableWrapper',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('CIcon',{attrs:{"name":"cil-grid"}}),_vm._v(" Listado de Máquinas ")]},proxy:true}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }